import styled from 'styled-components'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useSelector,useDispatch } from 'react-redux';
import { useState,useEffect } from 'react'
import ShoppingCartElement from "./shoppingCartElement.jsx"
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import  api  from "../../axios.js"
import { modifcarShoppingCart,estadoShoppingCart } from '../../redux/actions/shoppingCartActions.js';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const Container=styled.div`
	position:relative

`;

const ContainerShoppingCartIcon=styled.div`
	margin-left:5px;
	position:relative;
	border-radius:150px;
	height:40px;
	width:40px;
	display:flex;
	justify-content:center;
	align-items:center;
	transition:all 200ms;
	&:hover{
		background-color:#F1F1F1
	}


`;

const NumberOfArticles=styled.div`	
	position:absolute;
	font-size:10px;
	font-weight: bold;
	display:flex;
	justify-content:center;
	align-items:center;
	background-color:red;
	height:17px;
	width:17px;
	border-radius:150px;
	top:0px;
	right:0px;
	color:white
`;



const ContainerDetail=styled.div`
	position:absolute;
	right:-159px;
	top:50px;
	background-color:white;
	max-height:435px;
	width:300px;
	border-radius:5px;
	z-index:1;
	display:flex;
	flex-direction:column;
	align-items:center;
	

 `;

 const ContainerdatosShoppingCart=styled.div`
 	width:100%;
 	display:flex;
 	flex-direction:column;
 	align-items:center;
 	height:100%;


 `;
 const ContainerButonCntraccion=styled.div`
	position:absolute;
	top:1px;
	right:1px

`;



 const ContainerArticulos=styled.div`
	max-height:250px;
	width:95%; 		
	overflow:auto;
	&::-webkit-scrollbar{
		background-color:transparent;
		width:2px
	};
	&::-webkit-scrollbar-track{
		background:trasparent;		
		border-radius:25px
	};
	&::-webkit-scrollbar-thumb {
    	background: #27B0FE;
    	border-radius: 15px;
  	};
  	&::-webkit-scrollbar:horizontal{display:none}
 `;

const ContainerArticulo=styled.div`
	height:120px;
	width:250px;
	margin-left:18px;

 `;
 const ContainerSubtotal=styled.div`
	display:flex;
	justify-content:space-between;
	align-items:center;
	width:87%;


 `;

const Msj=styled.div`
	color:black;
	font-weight:bold;
	margin:10px;
`;

const MsjSubtotal=styled.div`
	color:black;	
	
	font-weight:bold;
`;



export default function ShoppingCard(props){
	let { openLoginShoppingCart } = props;
	let shoppingCart  = useSelector(state=>state.shoppingCart.reventas);
	let logeo  = useSelector(state=>state.login);
	let pais  = useSelector(state=>state.pais.pais);
	let [ subTotal,setSubTotal ]=useState(0);
	let [ openShoppingCart,setOpenShoppingCart]=useState(false);
	let dispatch=useDispatch();

	const handleClick=()=>{		
		if(openShoppingCart){setOpenShoppingCart(false)} else {setOpenShoppingCart(true)}
	}

	const Solicitar=async()=>{
		if(logeo.user&&logeo.login){ 
			try{
				if(window.confirm("desea enviar su pedido ")){
					if(logeo.user&&logeo.login&&shoppingCart){
						dispatch(estadoShoppingCart(1))
						let data={idUser:logeo.user.id,idsReventas:shoppingCart.map(ele=>ele.id),pais:pais.nombre};
						await api.post("/solicitudCompra",data);
						dispatch(modifcarShoppingCart([]));
						dispatch(estadoShoppingCart(0))
						alert("pedido enviado")
					}
				}
			}catch(err){console.log(err);alert(`error al grabar los datos : ${err.response.data}`)}
		}else{openLoginShoppingCart(true)}
	}

	useEffect(()=>{
			let acumulador=0;
			if(shoppingCart.length>0){
				shoppingCart.forEach((ele)=>{acumulador+=ele[`precio_${pais.nombre}`]   });
			setSubTotal(acumulador)}
	},[shoppingCart,pais.nombre])


	return(
		<Container>
			{openShoppingCart?<ContainerDetail>
				{shoppingCart.length>0?
				<ContainerdatosShoppingCart>
					<ContainerButonCntraccion>
						<Button onClick={()=>{setOpenShoppingCart(false)}} sx={{color:"black"}} endIcon={< KeyboardArrowUpIcon sx={{color:"black"}}/>} >cerrar</Button>
					</ContainerButonCntraccion>
					<Msj>{Object.keys(shoppingCart).length} Articulos</Msj>
					<ContainerArticulos>
				 	{shoppingCart.map(reventa=><ContainerArticulo  key={reventa.id}><ShoppingCartElement reventa={reventa} /></ContainerArticulo>)}
				 	</ContainerArticulos>
				 	<ContainerSubtotal><Msj>SUBTOTAL :</Msj><MsjSubtotal>{`${pais.modenaIcono} ${Number.parseFloat(subTotal).toFixed(2)} ` }</MsjSubtotal></ContainerSubtotal>
				 	<Button onClick={Solicitar} variant="contained" size="large"  sx={{ backgroundColor: 'black','&:hover': {backgroundColor: '#111111'},margin:'8px'}} endIcon={<SendIcon />}>Solicitar</Button>
					
				</ContainerdatosShoppingCart>:<Msj>no tiene productos en su carrito</Msj>}
			</ContainerDetail>:null}

			<ContainerShoppingCartIcon onClick={handleClick}>
				<ShoppingCartIcon style={{ fontSize: 28}}/>
    				{shoppingCart.length>0?<NumberOfArticles>{shoppingCart.length}</NumberOfArticles>:null}
    		</ContainerShoppingCartIcon>


		</Container>


		)
}